module.exports = __webpack_public_path__ + "static/media/YF20_4.bb40c3a7.jpg";